<script>
    export let visible = false;
  </script>
  
  {#if visible}
    <div class="snackbar">
      <div class="spinner"></div>
      Loading...
    </div>
  {/if}
  
  <style>
    .snackbar {
      position: fixed;
      bottom: 16px;
      left: 50%;
      transform: translateX(-50%);
      background-color: #333;
      color: white;
      padding: 16px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    }
  
    .spinner {
      border: 4px solid rgba(255, 255, 255, 0.3);
      border-radius: 50%;
      border-top: 4px solid #fff;
      width: 24px;
      height: 24px;
      animation: spin 1s linear infinite;
      margin-right: 12px;
    }
  
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  </style>
  